import React from 'react';
import * as Yup from 'yup';
import { Button } from '@economic/taco';

import { Field, Form } from '../../shared/components/Form';
import { t, tBB } from '../../shared/components/l10n/l10n';
import { useMutation } from '../../shared/components/Mutation';
import { ProgressDots } from '../../shared/components/ui/progressDots/ProgressDots';
import { OnboardingStatusCompanyData } from './types';

const bankValidationScheme = Yup.object().shape({
    name: Yup.string().required(() => t`ONBOARDING_GETTINGSTARTED_BANKINFO_NAME_REQUIRED`),
    number: Yup.string().required(),
    account: Yup.string().required(),
});

export const updateCompanyBankData = useMutation(`/onboarding/bank-data`, 'PUT');

interface Props {
    company: OnboardingStatusCompanyData;
    onDone: () => void;
    onBack: () => void;
    onSkip: () => void;
    stepCount: number;
}

export default function StepBankInfo({ company, onBack, onDone, onSkip, stepCount }: Props) {
    function saveBankInfo(values: any) {
        updateCompanyBankData(values);
        onDone();
    }

    const initialData = {
        name: company.bankName,
        number: company.bankRegistrationNumber,
        account: company.bankAccount,
        swift: company.bankSwift,
        iban: company.bankIban,
    };

    return (
        <div className="onboarding__container__fixed-size">
            <div className="onboarding onboarding__bank-info">
                <ProgressDots stepsCount={stepCount} currentStep={4} />

                <h2>{tBB(`ONBOARDING_GETTINGSTARTED_BANKINFO_TITLE`)}</h2>

                <p className="text-center">{t`ONBOARDING_GETTINGSTARTED_BANKINFO_CONTENT`}</p>

                <Form skipNotifications onSubmit={saveBankInfo} validationSchema={bankValidationScheme} initialData={initialData}>
                    <div className="onboarding__form-content">
                        <Field.Text name="name" label={t`ONBOARDING_GETTINGSTARTED_BANKINFO_NAME`} maxLength={100} />

                        <div className="columns">
                            <Field.Text name="number" label={t`ONBOARDING_GETTINGSTARTED_BANKINFO_NUMBER`} maxLength={50} />
                            <Field.Text name="account" label={t`ONBOARDING_GETTINGSTARTED_BANKINFO_ACCOUNT`} maxLength={50} />
                        </div>
                        <div className="columns">
                            <Field.Text name="swift" label={t`ONBOARDING_GETTINGSTARTED_BANKINFO_SWIFT`} maxLength={20} />
                            <Field.Text name="iban" label={t`ONBOARDING_GETTINGSTARTED_BANKINFO_IBAN`} maxLength={50} />
                        </div>
                    </div>
                    <div className="columns">
                        <div className="onboarding__navigation-buttons">
                            <div className="onboarding__skip-step">
                                <Button
                                    appearance="discrete"
                                    onClick={e => {
                                        e.preventDefault();
                                        onSkip();
                                    }}>{t`ONBOARDING_GETTINGSTARTED_SKIP`}</Button>
                            </div>

                            <Button appearance="primary" type="submit">{t`ONBOARDING_GETTINGSTARTED_NEXT`}</Button>

                            <Button
                                appearance="discrete"
                                onClick={e => {
                                    e.preventDefault();
                                    onBack();
                                }}>
                                {t`ONBOARDING_GETTINGSTARTED_BACK`}
                            </Button>
                        </div>
                    </div>
                </Form>
            </div>
        </div>
    );
}
